import { useEffect, useRef } from 'react';
import { BrowserRouter, useLocation, useNavigate } from 'react-router-dom';
import { AppRoutes } from './router';
import Navbar from './components/feature/Navbar';
import Footer from './components/feature/Footer';
import { supabase } from './lib/supabase';

const IDLE_TIMEOUT_MS = 10 * 60 * 1000; // 10 分鐘

function IdleLogout() {
  const navigate = useNavigate();
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(async () => {
        const { data: { user } } = await supabase.auth.getUser();
        if (user) {
          await supabase.auth.signOut();
          navigate('/login?reason=idle');
        }
      }, IDLE_TIMEOUT_MS);
    };

    const events = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'click'];
    events.forEach(e => window.addEventListener(e, resetTimer, { passive: true }));
    resetTimer();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach(e => window.removeEventListener(e, resetTimer));
    };
  }, [navigate]);

  return null;
}

function Layout() {
  const location = useLocation();
  const isBackend = location.pathname.startsWith('/admin') || location.pathname.startsWith('/teacher');

  return (
    <div className="flex flex-col min-h-screen">
      <IdleLogout />
      {!isBackend && <Navbar />}
      <main className="flex-1">
        <AppRoutes />
      </main>
      {!isBackend && <Footer />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Layout />
    </BrowserRouter>
  );
}

export default App;
